import { Component, input, signal } from '@angular/core';
import { CwList, CwListItem } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs';
import { LastContext, Site, User } from '~/app/models/User';
import { Dialog } from '~/app/services/dialog.service';
import { UserService } from '~/app/services/user.service';

@Component({
  selector: 'gplus-context-modal',
  imports: [TranslateModule, CwList, CwListItem],
  templateUrl: './context-modal.component.html',
  styleUrl: './context-modal.component.scss'
})
export class ContextModalComponent {
  public dialog = input<Dialog>();
  public sites = signal<Array<Site>>([]);
  public areWardsAvailable = signal<boolean>(false);

  constructor(private readonly userService: UserService) {
    this.userService
      .getMe()
      .pipe(take(1))
      .subscribe((me: User) => {
        this.sites.set(me.sites || []);
        this.areWardsAvailable.set(this.sites().some((site) => !!site.units.length));
      });
  }

  public selected(context: LastContext) {
    this.dialog().confirm.next(context);
  }
}
